import React from 'react';
import { connect } from 'react-redux';
import { addSMSKeywordRecipient } from '../redux/FeedbackRedux';
import FormError from "../FormError";

class PotentialRecipientsSMS extends React.Component {
  constructor(props) {
    super(props);
    this.state = { phone: "", name: "" };

    this.handleAddSMSRecipients = this.handleAddSMSRecipients.bind(this);
  }

  componentDidMount() {
  }

  handleClick(event) {
  }

  handleAddSMSRecipients(user, event) {
    event.preventDefault();
    var phone_map = this.props.state.phone_recipients.map((item, key) => item.phone);
    if (phone_map.includes(user.phone)) {
      this.setState({ phone_error: "This phone number is already in the list." });
      return;
    } else {
      var info = { id: user.id, phone: user.phone, name: (user.firstname + " " + user.lastname), email_error: this.props.email_error };
      this.props.dispatch(addSMSKeywordRecipient(user));
      this.setState({ phone_error: false });
      jQuery('.modal').modal('hide');
    }
  }

  render() {
    return (
      <div className="potentialRecipientsList">
        <p>
          {__('Due to the fact that it can take a few minutes for these reports to generate, the XLS export will be generated and emailed to the address you enter below.')}
        </p>
        <FormError error_message={this.state.phone_error}></FormError>
        <hr />

        <div className="input-group">
          <input className="input form-control" type="email" placeholder="email@domain.com" id="recipient_email"
            defaultValue={this.props.state.userEmail || this.props.state.currentUser?.email || ''} />
        </div>
      </div>
    );

  }
}

function mapStateToProps(state) {
  return { state: state }
}

export default connect(mapStateToProps)(PotentialRecipientsSMS);
